interface IsPromoActiveProps {
	startDate: string | null
	endDate: string
}
export function isPromoActive({ startDate, endDate }: IsPromoActiveProps) {
	const nowMs = Date.now()
	const promoEndDateMs = new Date(endDate).getTime()
	// Date since the promo banner will be shown
	const promoStartDateMs = startDate ? new Date(startDate).getTime() : 0

	return promoStartDateMs <= nowMs && nowMs < promoEndDateMs
}
